import { Column, ColumnName } from './column';
import { TableName } from './table';

export type SimplifiedTableColumns = Record<
  TableName,
  { name: ColumnName; sourceType: Column.SourceType }[]
>;

export type TableColumns = Record<TableName, Column[]>;

export namespace TableColumns {
  export function fromSimplified(stc: SimplifiedTableColumns): TableColumns {
    return Object.fromEntries(
      Object.entries(stc).map(([table, columns]) => [
        table,
        columns.map(col => ({ ...col, table })),
      ])
    );
  }
}
